import { landingPageInitialState } from "./uiLandingPageLandingState";
import { makeLandingPageActions } from "./uiLandingPageLandingActions";

export const createLandingPageSlice = (set, get) => ({
  landingPage: landingPageInitialState,
  landingPageActions: Object.freeze(makeLandingPageActions(set, get)),
});
